export const makeApiCall = async (url) => {
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};


export const getFullUrl = () => {
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`;
};